import React from 'react';
import './ForCreators.css';

const bentos = [
  { num: '20+', title: 'Active creators', desc: 'Join a thriving community already earning through GoSnap.', delay: 'rd1', small: true },
  { num: '15+', title: 'Bookings/month', desc: 'Top creators do 15+ sessions monthly — all booked through GoSnap.', delay: 'rd1', small: true },
  { num: '24hr', title: 'Instant payouts', desc: 'Get paid within 24 hours of every completed shoot. No invoice chasing.', delay: 'rd2', small: true },
];

const handleAnchorClick = (e, href) => {
  e.preventDefault();
  const target = document.querySelector(href);
  if (target) target.scrollIntoView({ behavior: 'smooth' });
};

const ForCreators = () => (
  <section className="for-creators" id="creators-join">
    <div className="container">
      <div className="reveal">
        <span className="sec-label">Join the creator economy</span>
        <h2 className="sec-h2">Turn Your Camera<br />Into a <em>Career</em></h2>
        <p className="sec-p">GoSnap connects talented videographers with clients who need their skills — right now, near them.</p>
      </div>
      <div className="creators-bento">
        {/* Big card */}
        <div className="bento big reveal">
          <div className="bento-num">₹30K+</div>
          <div className="bento-title">Top creators earn monthly</div>
          <div className="bento-desc">Set your own schedule and rates. GoSnap brings the clients, bookings, and instant payments.</div>
          <a href="#contact" className="btn-primary bento-cta" onClick={(e) => handleAnchorClick(e, '#contact')}>
            Join as Creator →
          </a>
        </div>
        {/* Small cards */}
        {bentos.map((b) => (
          <div key={b.num} className={`bento reveal ${b.delay}`}>
            <div className="bento-num">{b.num}</div>
            <div className="bento-title">{b.title}</div>
            <div className="bento-desc">{b.desc}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ForCreators;
